import { ComplaintStep } from './chatbot.models';

// Citizen Details Steps - collected before complaint details
// maxLength values match the form's Validators.maxLength() exactly.
export const CITIZEN_DETAILS_STEPS: ComplaintStep[] = [
  { field: 'citizenName',     label: 'CHATBOT_CITIZEN_NAME',     type: 'text',     required: true,  maxLength: 30  },
  { field: 'citizenGender',   label: 'CHATBOT_CITIZEN_GENDER',   type: 'dropdown', required: true                  },
  { field: 'citizenCNIC',     label: 'CHATBOT_CITIZEN_CNIC',     type: 'text',     required: true,  maxLength: 15  },
  { field: 'citizenPhone',    label: 'CHATBOT_CITIZEN_PHONE',    type: 'text',     required: true,  maxLength: 15  },
  { field: 'citizenEmail',    label: 'CHATBOT_CITIZEN_EMAIL',    type: 'text',     required: false, maxLength: 60  },
  { field: 'citizenPassport', label: 'CHATBOT_CITIZEN_PASSPORT', type: 'text',     required: false, maxLength: 9   },
  { field: 'citizenAddress',  label: 'CHATBOT_CITIZEN_ADDRESS',  type: 'text',     required: false, maxLength: 200 },
  { field: 'isAnonymous',     label: 'CHATBOT_ANONYMOUS_COMPLAINT', type: 'yesno',  required: true  },
];

// Complaint Details Steps - collected after citizen details.
// required: false  → chatbot shows a "Skip" button; form default or empty value is acceptable.
// required: true   → chatbot blocks progression until the user makes a choice.
export const COMPLAINT_DETAILS_STEPS: ComplaintStep[] = [
  // Segment / Priority / Severity  (priority & severity have safe form defaults)
  { field: 'segmentId',           label: 'CHATBOT_SEGMENT',           type: 'dropdown', required: true  },
  { field: 'priority',            label: 'CHATBOT_PRIORITY',          type: 'dropdown', required: false },  // default: LOW
  { field: 'severity',            label: 'CHATBOT_SEVERITY',          type: 'dropdown', required: false },  // default: EASY
  // Identity / complaint type
  { field: 'complaintCategoryId', label: 'CHATBOT_COMPLAINT_TYPE',    type: 'dropdown', required: true  },
  { field: 'complaintSubcategoryId', label: 'CHATBOT_COMPLAINT_SUBTYPE', type: 'dropdown', required: true },
  // Location
  { field: 'divisionId',          label: 'CHATBOT_DIVISION',          type: 'dropdown', required: true  },
  { field: 'districtId',          label: 'CHATBOT_DISTRICT',          type: 'dropdown', required: true  },
  { field: 'tehsilId',            label: 'CHATBOT_TEHSIL',            type: 'dropdown', required: true  },
  { field: 'mouzaId',             label: 'CHATBOT_MOUZA',             type: 'dropdown', required: false },  // no validator in form
  // Complaint body
  { field: 'complaintAddress',    label: 'CHATBOT_COMPLAINT_ADDRESS', type: 'text',     required: true,  maxLength: 200  },
  { field: 'otherForum',          label: 'CHATBOT_OTHER_FORUM',       type: 'text',     required: false, maxLength: 200  },
  { field: 'complaintDetails',    label: 'CHATBOT_COMPLAINT_DETAILS', type: 'text',     required: true,  maxLength: 1500 },
  // Additional details
  { field: 'workCode',            label: 'CHATBOT_WORK_CODE',         type: 'dropdown', required: true  },
  { field: 'complaintSource',     label: 'CHATBOT_COMPLAINT_SOURCE',  type: 'dropdown', required: false },  // no validator in form
  { field: 'helplineIdentifier',  label: 'CHATBOT_HELPLINE_IDENTIFIER', type: 'dropdown', required: false }, // no validator in form
  // Document
  { field: 'documentAttachment',  label: 'CHATBOT_DOCUMENT_ATTACHMENT', type: 'yesno', required: false },
];

// Combined steps: citizen details first, then complaint details
export const COMPLAINT_STEPS: ComplaintStep[] = [
  ...CITIZEN_DETAILS_STEPS,
  ...COMPLAINT_DETAILS_STEPS,
];

export const CHATBOT_TRACKING_ID_PATTERN = /^GRMS-\d{8}-\d{4,6}$/;
